import { InjectionToken } from '@angular/core';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Database, getDatabase } from 'firebase/database';
import { connectFunctionsEmulator, Functions, getFunctions } from 'firebase/functions';
import { environment } from '../../environments/environment';

function firebaseApp(): FirebaseApp {
  return getApps()[0] ?? initializeApp(environment.firebase);
}

export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH', {
  providedIn: 'root',
  factory: () => getAuth(firebaseApp()),
});

export const FIREBASE_DB = new InjectionToken<Database>('FIREBASE_DB', {
  providedIn: 'root',
  factory: () => getDatabase(firebaseApp()),
});

/** The region the functions pin themselves to in `functions/src/index.ts`. */
export const FIREBASE_FUNCTIONS = new InjectionToken<Functions>('FIREBASE_FUNCTIONS', {
  providedIn: 'root',
  factory: () => {
    const functions = getFunctions(firebaseApp(), 'us-central1');
    if (!environment.production) {
      connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    }
    return functions;
  },
});
